const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78.796 37.03 c -0.27 -2.828 -0.96 -5.534 -2.008 -8.054 C 72.57 18.822 62.56 11.682 50.88 11.682 c -5.449 0 -10.534 1.554 -14.837 4.243 c -6.649 4.156 -11.43 11.021 -12.802 19.051 h -3.198 C 8.974 34.976 0 43.95 0 55.02 v 0 c 0 11.07 8.974 20.044 20.044 20.044 h 49.912 C 81.026 75.064 90 66.09 90 55.02 v 0 C 90 47.124 85.432 40.297 78.796 37.03 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(105,227,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.395 6.861 L 11.395 6.861 c 0.271 -0.112 0.292 -0.362 0.292 -0.436 c 0 -0.074 -0.021 -0.324 -0.292 -0.436 c -0.136 -0.056 -0.242 -0.163 -0.299 -0.299 c -0.056 -0.136 -0.056 -0.286 0 -0.423 l 0.36 -0.868 c 0.117 -0.281 0.44 -0.415 0.722 -0.299 c 0.271 0.112 0.462 -0.05 0.515 -0.102 c 0.052 -0.052 0.215 -0.244 0.102 -0.515 c -0.056 -0.136 -0.056 -0.286 0 -0.423 c 0.056 -0.136 0.163 -0.243 0.299 -0.299 l 0.869 -0.36 c 0.281 -0.116 0.605 0.018 0.722 0.299 c 0.112 0.27 0.362 0.291 0.436 0.291 s 0.324 -0.021 0.436 -0.292 c 0.056 -0.136 0.163 -0.243 0.299 -0.299 c 0.136 -0.056 0.286 -0.056 0.423 0 l 0.868 0.36 c 0.136 0.056 0.243 0.163 0.299 0.299 s 0.056 0.286 0 0.423 c -0.112 0.271 0.05 0.462 0.102 0.515 c 0.052 0.052 0.244 0.215 0.515 0.102 c 0.136 -0.056 0.286 -0.056 0.423 0 c 0.136 0.056 0.243 0.163 0.299 0.299 l 0.36 0.868 c 0.056 0.136 0.056 0.286 0 0.423 c -0.056 0.136 -0.163 0.243 -0.299 0.299 c -0.27 0.112 -0.292 0.362 -0.292 0.436 s 0.021 0.324 0.292 0.436 c 0.281 0.117 0.415 0.44 0.299 0.722 l -0.36 0.868 c -0.056 0.136 -0.163 0.242 -0.299 0.299 c -0.136 0.056 -0.286 0.056 -0.423 0 c -0.27 -0.112 -0.462 0.05 -0.515 0.102 c -0.052 0.052 -0.214 0.244 -0.102 0.515 c 0.117 0.281 -0.017 0.605 -0.299 0.722 l -0.868 0.36 c -0.068 0.028 -0.14 0.042 -0.211 0.042 c -0.072 0 -0.143 -0.014 -0.211 -0.042 c -0.136 -0.056 -0.243 -0.163 -0.299 -0.299 c -0.112 -0.271 -0.362 -0.292 -0.436 -0.292 l 0 0 c -0.074 0 -0.324 0.021 -0.436 0.292 c -0.117 0.281 -0.44 0.415 -0.722 0.299 l -0.869 -0.36 c -0.281 -0.117 -0.415 -0.44 -0.299 -0.722 c 0.112 -0.271 -0.05 -0.462 -0.102 -0.515 c -0.052 -0.052 -0.244 -0.215 -0.515 -0.102 c -0.281 0.116 -0.605 -0.018 -0.722 -0.299 l -0.36 -0.868 C 10.98 7.301 11.114 6.977 11.395 6.861 z M 15.121 7.949 c 0.841 0 1.525 -0.684 1.525 -1.525 s -0.684 -1.525 -1.525 -1.525 s -1.525 0.684 -1.525 1.525 S 14.28 7.949 15.121 7.949 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,118,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(3.89 0 0 3.89 -1.9444444444444287 -1.9444444444444287) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.939 58.51 H 36.45 v -3.874 h 3.36 c 0.847 0 1.534 -0.687 1.534 -1.534 s -0.687 -1.534 -1.534 -1.534 h -3.36 v -3.874 h 5.489 c 0.847 0 1.534 -0.687 1.534 -1.534 c 0 -0.847 -0.687 -1.534 -1.534 -1.534 h -7.023 c -0.847 0 -1.534 0.687 -1.534 1.534 v 13.885 c 0 0.847 0.687 1.534 1.534 1.534 h 7.023 c 0.847 0 1.534 -0.687 1.534 -1.534 S 42.787 58.51 41.939 58.51 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,118,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.447 60.044 v -4.288 c 0 -1.013 -0.376 -1.93 -0.976 -2.655 c 0.6 -0.725 0.976 -1.642 0.976 -2.655 v -1.633 c 0 -2.31 -1.879 -4.189 -4.189 -4.189 h -4.78 c -0.847 0 -1.534 0.687 -1.534 1.534 v 6.942 v 6.942 c 0 0.847 0.687 1.534 1.534 1.534 s 1.534 -0.687 1.534 -1.534 v -5.408 h 3.246 c 0.618 0 1.121 0.502 1.121 1.121 v 4.288 c 0 0.847 0.687 1.534 1.534 1.534 C 28.761 61.578 29.447 60.891 29.447 60.044 z M 22.013 51.567 v -3.874 h 3.246 c 0.618 0 1.121 0.502 1.121 1.121 v 1.633 c 0 0.618 -0.503 1.121 -1.121 1.121 H 22.013 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,118,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.521 44.625 h -8.759 c -0.847 0 -1.534 0.687 -1.534 1.534 c 0 0.847 0.687 1.534 1.534 1.534 h 2.845 v 12.351 c 0 0.847 0.687 1.534 1.534 1.534 s 1.534 -0.687 1.534 -1.534 V 47.693 h 2.845 c 0.847 0 1.534 -0.687 1.534 -1.534 C 71.056 45.311 70.368 44.625 69.521 44.625 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,118,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.729 47.693 h 1.287 c 0.7 0 1.27 0.521 1.27 1.163 c 0 0.847 0.687 1.534 1.534 1.534 s 1.534 -0.687 1.534 -1.534 c 0 -2.333 -1.947 -4.231 -4.339 -4.231 h -1.287 c -2.475 0 -4.488 1.963 -4.488 4.375 v 1.261 c 0 2.412 2.013 4.375 4.488 4.375 h 1.139 c 0.783 0 1.419 0.586 1.419 1.306 v 1.261 c 0 0.72 -0.636 1.306 -1.419 1.306 H 50.58 c -0.701 0 -1.271 -0.522 -1.271 -1.164 c 0 -0.847 -0.687 -1.534 -1.534 -1.534 s -1.534 0.687 -1.534 1.534 c 0 2.333 1.947 4.232 4.34 4.232 h 1.287 c 2.474 0 4.487 -1.963 4.487 -4.375 v -1.261 c 0 -2.412 -2.013 -4.375 -4.487 -4.375 h -1.139 c -0.783 0 -1.42 -0.586 -1.42 -1.306 v -1.261 C 49.309 48.279 49.946 47.693 50.729 47.693 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,118,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.58 66.32 h -2.631 c -2.497 0 -4.528 2.031 -4.528 4.528 v 10.89 c 0 0.847 0.687 1.534 1.534 1.534 c 0.847 0 1.534 -0.687 1.534 -1.534 V 76.33 h 5.55 v 5.408 c 0 0.847 0.687 1.534 1.534 1.534 s 1.534 -0.687 1.534 -1.534 v -10.89 C 39.108 68.351 37.077 66.32 34.58 66.32 z M 30.49 73.262 v -2.414 c 0 -0.805 0.655 -1.46 1.46 -1.46 h 2.631 c 0.805 0 1.46 0.655 1.46 1.46 v 2.414 H 30.49 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,118,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.309 66.32 c -0.847 0 -1.534 0.687 -1.534 1.534 v 13.885 c 0 0.847 0.687 1.534 1.534 1.534 s 1.534 -0.687 1.534 -1.534 V 67.854 C 60.843 67.007 60.156 66.32 59.309 66.32 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,118,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.007 66.32 h -5.083 c -0.847 0 -1.534 0.687 -1.534 1.534 v 7.788 v 6.096 c 0 0.847 0.687 1.534 1.534 1.534 s 1.535 -0.687 1.535 -1.534 v -4.562 h 3.549 c 2.337 0 4.239 -1.902 4.239 -4.24 V 70.56 C 54.245 68.221 52.344 66.32 50.007 66.32 z M 51.177 72.937 c 0 0.646 -0.525 1.172 -1.171 1.172 h -3.55 v -4.72 h 3.55 c 0.645 0 1.171 0.525 1.171 1.172 V 72.937 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,118,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestApi);
export default __webpack_public_path__ + "static/media/rest-api.dd9453a568289c11b054aedcca8cca4f.svg";
export { ForwardRef as ReactComponent };